import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDateHourPipe } from './pipes/dynamic-datehour.pipe'; 
import { DynamicDatePipe } from './pipes/dynamic-date.pipe';
import { StorageFormatPipe } from './pipes/storageFormat.pipe';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  declarations: [
    DynamicDateHourPipe, 
    DynamicDatePipe,
    StorageFormatPipe,
    SafePipe
  ],
  imports: [
    CommonModule, 
  ],
  exports: [
    DynamicDateHourPipe, 
    DynamicDatePipe,
    StorageFormatPipe,
    SafePipe
  ],
})
export class SharedModule {}
